/**
 * CookieStore Utility.
 *
 * Abstracts common cookie storage operations.
 *
 */
// imports
import Cookies from 'js-cookie';
import BaseStore from './storebase';


/**
 * CookieStore Utility class.
 */
export default class CookieStore extends BaseStore {

    /**
     * Check if cookie storage is possible by setting an indicator value.
     */
    public checkAvailability() : void {
        this.set(`${this.prefix}-cke-test`, ['1']);
    }


    /**
     * Return all cookies that are available on the document object.
     * 
     * @returns Record<string, string>
     */
    public getAll() : Record<string, string> {
        if (this.status) {
            return Cookies.get();
        }
        return {};
    }

    /**
     * Passively get the cookie storage object located at key.
     * Handles if cookie storage is not available by returning false
     * (for failure).
     *
     * @param {string} key
     * @return {StoreGetResult}
     */
    public get(key: string) : Array<string> {
        if (this.status) {

            try {
                const value = Cookies.get(key);
                if (typeof(value) === 'undefined') {
                    return [];
                }
                if (value) {
                    return JSON.parse(value);
                }
            } catch (error) {
                this.fail(error);
            }
        }
        return [];
    }

    /**
     * Passively set the cookie storage object located at key with value.
     * Handles if cookie storage is not available by returning false.
     *
     * @param {string} key
     * @param {string | object} value
     * @return {StoreSetResult}
     */
    public set(key: string, value: Array<string>): boolean {
        if (this.status) {
            try {
                const jsonValue = JSON.stringify(value);
                Cookies.set(key, jsonValue, {sameSite: 'Strict'});
                // ensure the cookie was set properly
                if (JSON.stringify(this.get(key)) !== jsonValue) {
                    return false;
                }
                return true;
            } catch (error) {
                return this.fail(error);
            }
        }
        return false;
    }

}
